var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.text || _vm.iconLeft || _vm.iconRight)?_c('p',{staticClass:"tag",class:_vm.extraClass},[(_vm.iconLeft)?_c('SvgIcon',{attrs:{"name":_vm.iconLeft}}):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),(_vm.iconRight)?_c('SvgIcon',{attrs:{"name":_vm.iconRight}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }